import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { ApiResponse } from '../../main/_models/api-response';
import { first, map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Utente } from 'src/app/main/_models/utente';
import { UserService } from './user.service';
import { SaveTempService } from './save-temp.service';
import { Router } from '@angular/router';
import { CheckProfileService } from './check-profile.service';
import { AlertService } from './alert.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {

	public currentUser: Observable<Utente>;
	private currentUserSubject: BehaviorSubject<Utente>;
	private jwtHelper: JwtHelperService = new JwtHelperService();

	constructor(
		private storageService: StorageService,
		private http: HttpClient,
		private config: AppConfig,
		private usersService: UserService,
		private saveTempService: SaveTempService,
		private router: Router,
		//private checkprofileService: CheckProfileService,
		private alertService: AlertService,
		private translateService: TranslateService
	) {
		this.currentUserSubject = new BehaviorSubject<Utente>(this.storageService.getItem("current_user"))
		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue() {
		return this.currentUserSubject.value;
	}

	refreshToken() {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/refreshtoken`, null).pipe(map(response => {
			this.afterLogin(response, false, true, null);
			return response;
		}));
	}

	afterLogin(response: ApiResponse, remember: boolean, onlyJwt: boolean, returnUrl: string) {
		if (response && response.status == "OK") {
			if (response && response.result.jwt) {
				var user = this.jwtHelper.decodeToken(response.result.jwt);
				if (user.user) {
					var u = <Utente>user.user;
					u.password = "";
					this.storageService.storePlain('access_token', response.result.jwt);
					if (remember)
						this.storageService.storeLocalPlain('access_token', response.result.jwt);
					this.storageService.store('current_user', u);
					this.storageService.storePlain("language", u.lingua);
					this.translateService.use(u.lingua);
					this.currentUserSubject.next(u);
					if (!onlyJwt) {
						this.usersService.preferences()
							.pipe(first())
							.subscribe(
								data => {
									if (data.status === 'OK' && data.result) {
										this.saveTempService.empty();
										this.storageService.store("user_preferences", data.result);
										if (!returnUrl || (u.profilo == "D" && returnUrl.indexOf("/driver-app/") == -1))
											this.router.navigate([u.default_homepage]);
										else
											this.router.navigate([returnUrl]);
										//this.checkprofileService.getMessages();
									} else
										this.alertService.error(data.error_message);
								});
					}
				}
			}
		}
	}

	//username: string, password: string, remember: number, profilo: string = "", mkt: string = ""
	login(params) {
		const remember = params.remember;
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/authenticate`, params)
			.pipe(map(response => {
				this.afterLogin(response, remember, false, params.returnUrl || null);
				return response;
			}));
	}

	loginRemember(token: string) {
		this.storageService.storePlain("access_token", token);
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/refreshtoken`, {})
			.pipe(map(response => {
				this.storageService.clear("access_token");
				this.afterLogin(response, false, false, null);
				return response;
			}));
	}

	clearClientSession() {
		this.currentUserSubject.next(null);
		sessionStorage.clear();
		localStorage.clear();
	}

	logout(force: boolean) {

		force = force || false;

		let ret: any;

		if (!force)
			ret = this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/logout`, {});
		else
			ret = null;

		return ret;

	}

	public getBackendVersion() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/version`);
	}

}
